module.exports = __webpack_public_path__ + "static/media/logonfh.ab4ac085.png";